// imports
import { useSelector } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import EmptySidebar from './empty';
import Utils from '../../../common/utils';
import { ICON, IMAGE } from '../../../assets';
import PaperBG from '../../../atoms/background/paper';
import { HeroListFilter } from '../../../common/types';
import { HeroNFT } from '../../../repositories/web3/types';
import { selectConfig, selectUserHeroes } from '../../../repositories/store/slices';

// interfaces / types / consts
interface Props {
  filter: HeroListFilter;
  hero: HeroNFT | undefined;
}

// exports
export default function HeroDetailView(props: Props): JSX.Element {
  const { hero, filter } = props;
  // hooks configuration
  const { texts } = useSelector(selectConfig);
  const scrollableDivRef = useRef<HTMLDivElement>(null);
  const { fetchStatus } = useSelector(selectUserHeroes);
  useEffect(() => { if (scrollableDivRef.current) { scrollableDivRef.current.scrollTop = 0; } }, [hero]);

  const traitIds = hero?.traitIds;
  const heroSpecies = hero ? Utils.hero.getSpecies(traitIds) : filter.split('_')[1];
  let textKey = fetchStatus === 'loading' ? 'hero_loading' : `hero_species_${heroSpecies || 'all'}`;
  if (hero && Utils.hero.getRarity(traitIds) === 'mythic') { textKey = `hero_token_${hero.tokenId}`; }

  return (
    <div className="dv-container">
      <PaperBG fold />
      <div className="dv-content">
        {hero ? (
          <>
            <div className="dv-title">
              <div className="heading">
                <img className="left-motif" src={IMAGE.HERO_TITLE_MOTIF} alt="Left Motif" />
                <span>{hero?.name}</span>
                <img className="right-motif" src={IMAGE.HERO_TITLE_MOTIF} alt="Right Motif" />
              </div>
              <div className="type">{heroSpecies}</div>
              <div className="id">{`#${`${hero.tokenId}`.padStart(4, '0')}`}</div>
            </div>
            <div ref={scrollableDivRef} className="scrollable-section">
              <div className="dv-image-container">
                <div className="dv-avatar">
                  <img className="frame" src={IMAGE.AVATAR_FRAME} alt="avatar_frame" />
                  <img
                    alt="hero"
                    className="avatar hero"
                    src={hero?.image || IMAGE.HERO_PLACEHOLDER}
                    onError={({ currentTarget }) => { currentTarget.src = IMAGE.HERO_PLACEHOLDER; }}
                  />
                </div>
              </div>
              <div className="dv-details">
                <p>{texts[textKey]?.body}</p>
                <div className="traits">
                  {traitIds?.map((trait) => <div key={trait} id={trait} className="trait"><img src={ICON[trait.toUpperCase()]} alt="icon" /></div>)}
                </div>
              </div>
            </div>
          </>
        ) : (
          <EmptySidebar
            placeholderImg={IMAGE.HERO_PLACEHOLDER}
            title={texts[textKey]?.title || 'Loading...'}
            body={texts[textKey]?.body || 'Loading hero details...'}
          />
        )}
      </div>
    </div>
  );
}
